var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Supply_demand_container"},[_c('div',{staticClass:"Supply_demand_content"},[_c('router-view')],1),_c('bottom-url')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }